module.exports = __webpack_public_path__ + "static/img_1590-acc3b47e47a0d9218f819d9374cac5ca.jpg";